import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { closeCurrentPopup } from '@paragon/popup-state';

import { useAppDispatch, useAppSelector } from '../hooks';
import { CreateAssemblyGroupsDialog } from './create-assembly-groups/CreateAssemblyGroupsDialog';
import { CreateTrailerDialog } from './CreateTrailerDialog';
import { CreateTruckDriverDialog } from './CreateTruckDriverDialog';
import {
  CREATE_ASSEMBLY_GROUPS_DIALOG,
  CREATE_TRAILER_DIALOG,
  CREATE_TRUCK_DRIVER_DIALOG,
  EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG,
  EDIT_DIRECTORY_DIALOG,
  EDIT_LINE_DIALOG,
  EDIT_STATION_DIALOG,
  PERMANENT_LINKS_DIALOG,
  SEND_ASSEMBLY_GROUP_DIALOG,
  STATION_INSERTION_DIALOG,
} from './dialogs';
import { EditAssemblyGroupPropertiesDialog } from './EditAssemblyGroupPropertiesDialog';
import { EditDirectoryDialog } from './EditDirectoryDialog';
import { EditLineDialog } from './EditLineDialog';
import { EditStationDialog } from './EditStationDialog';
import { PermanentLinksDialog } from './PermanentLinksDialog';
import { SendAssemblyGroupDialog } from './SendAssemblyGroupDialog';
import { StationInsertionDialog } from './StationInsertionDialog';

export function DialogContainer() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const popupState = useAppSelector((state) => state.popup);

  useEffect(() => {
    if (popupState.popupName) {
      dispatch(closeCurrentPopup());
    }
    // This effect is intentionally run when the location changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, dispatch]);

  switch (popupState.popupName) {
    case EDIT_DIRECTORY_DIALOG:
      return <EditDirectoryDialog {...popupState.options} />;

    case EDIT_LINE_DIALOG:
      return <EditLineDialog {...popupState.options} />;

    case EDIT_STATION_DIALOG:
      return <EditStationDialog {...popupState.options} />;

    case PERMANENT_LINKS_DIALOG:
      return <PermanentLinksDialog {...popupState.options} />;

    case STATION_INSERTION_DIALOG:
      return <StationInsertionDialog {...popupState.options} />;

    case CREATE_TRAILER_DIALOG:
      return <CreateTrailerDialog />;

    case CREATE_TRUCK_DRIVER_DIALOG:
      return <CreateTruckDriverDialog />;

    case CREATE_ASSEMBLY_GROUPS_DIALOG:
      return <CreateAssemblyGroupsDialog {...popupState.options} />;

    case SEND_ASSEMBLY_GROUP_DIALOG:
      return <SendAssemblyGroupDialog {...popupState.options} />;

    case EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG:
      return <EditAssemblyGroupPropertiesDialog {...popupState.options} />;

    case null:
    default:
      return null;
  }
}
